import { SET_LOADING, UPDATE_RULES_SERVICE } from '../constants'
import { convertRule } from '../utils'
import { loadRules, setGlobalAlert } from '.'

export default (channel, abortController = new AbortController(), unitSet, service = false) => (dispatch, getState) => {
    const { assetId, curves } = getState().editorReducer

    if (assetId || assetId === 0) {
        if (!service) dispatch({ type: SET_LOADING, loading: true })

        fetch(`/services/plugin-channel-alarms/alarm-rules/${assetId}${!service && channel ? '/' + channel : ''}`, {
            signal: abortController.signal
        })
            .then(r => {
                if (r.ok) {
                    return r.json()
                }

                return new Promise(resolve => resolve({ success: false, error: r.status + ' - ' + r.statusText }))
            })
            .then(async r => {
                if (service) {
                    dispatch({ type: UPDATE_RULES_SERVICE, rules: r })
                } else {
                    dispatch(
                        loadRules(
                            unitSet
                                ? await Promise.all(r.userRules.map(r => convertRule(r, unitSet, curves)))
                                : r.userRules,
                            unitSet
                                ? await Promise.all(r.allUsersRules.map(r => convertRule(r, unitSet, curves)))
                                : r.allUsersRules,
                            r.canEditAllUsers
                        )
                    )
                }
            })
            .catch(err => {
                if (!service) dispatch({ type: SET_LOADING, loading: false })

                if (err.name !== 'AbortError') {
                    dispatch(setGlobalAlert('Error getting rules', false))
                    console.error('Error getting rules:', err)
                }
            })
    }
}
